import { createAction, props } from '@ngrx/store'
import { BaseEventTicketCheckInEntity } from './base-event-ticket-check-ins.models'
import { HttpErrorResponse } from '@angular/common/http'

export const loadEventTicketCheckIns = createAction(
  '[EventTicketCheckIns Page] Load EventTicketCheckIns',
  (offset?: number) => ({ offset }),
)

export const loadEventTicketCheckInsSuccess = createAction(
  '[EventTicketCheckIns/API] Load EventTicketCheckIns Success',
  props<{ eventTicketCheckIns: BaseEventTicketCheckInEntity[] }>(),
)

export const loadEventTicketCheckInsFailure = createAction(
  '[EventTicketCheckIns/API] Load EventTicketCheckIns Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateCount = createAction('[EventTicketCheckIns/Page] Update Count', props<{ count: number }>())

export const syncSelectedEventTicketCheckIn = createAction(
  '[EventTicketCheckIns Page] Sync Selected EventTicketCheckIn',
)

export const syncSelectedEventTicketCheckInSuccess = createAction(
  '[EventTicketCheckIns/API] Sync Selected EventTicketCheckIn Success',
  props<{ eventTicketCheckIn: BaseEventTicketCheckInEntity }>(),
)

export const syncSelectedEventTicketCheckInFailure = createAction(
  '[EventTicketCheckIns/API] Sync Selected EventTicketCheckIn Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearSelectedEventTicketCheckIn = createAction(
  '[EventTicketCheckIns Page] Clear Selected EventTicketCheckIn',
)

export const clearEventTicketCheckIns = createAction('[EventTicketCheckIns Page] Clear EventTicketCheckIns')
